import getMuiTheme from 'material-ui/styles/getMuiTheme';
import {
    indigo500,
    indigo700,
    blueA200,
    grey100,
    grey400,
    grey500,
} from 'material-ui/styles/colors';

const theme = getMuiTheme({
    palette: {
        primary1Color: indigo500,
        primary2Color: indigo700,
        primary3Color: grey400,
        accent1Color: blueA200,
        accent2Color: grey100,
        accent3Color: grey500,
    },
    textField: {
        disabledTextColor: 'rgba(0,0,0,0.6)',
        hintColor: 'rgba(0,0,0,.6)',
        floatingLabelColor: 'rgba(0,0,0,.8)',
    },
    tabs: {
        backgroundColor: '#ffffff',
        selectedTextColor: '#000000',
        textColor: 'rgba(0,0,0,.6)',
    },
});

export default theme;



// WEBPACK FOOTER //
// ./src/theme.js